var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCarrotDown = function SvgCarrotDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.308 9a1.05 1.05 0 011.484 0l4.158 4.158L16.108 9a1.05 1.05 0 011.485 1.485l-4.9 4.9a1.05 1.05 0 01-1.486 0l-4.9-4.9a1.05 1.05 0 010-1.485z",
    fill: "#9CA6AD"
  })));
};

export default SvgCarrotDown;